import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Outlet, useNavigate } from 'react-router-dom'

import { IPublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'

import { CustomNavigationClient } from '../../../utils/auth'
import ThemeContextProvider from '../../context/ThemeContextProvider'

type Props = {
  publicClientApplication: IPublicClientApplication
}

export const ProviderLayout: React.FC<Props> = ({ publicClientApplication }) => {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const navigate = useNavigate()
  const navigationClient = new CustomNavigationClient(navigate)
  publicClientApplication.setNavigationClient(navigationClient)

  return (
    <MsalProvider instance={publicClientApplication}>
      <HelmetProvider>
        <ThemeContextProvider>
          <Outlet />
        </ThemeContextProvider>
      </HelmetProvider>
    </MsalProvider>
  )
}
